export enum threeSixtyKeys {
  Interior = "360Exterior",
  Exterior = "360Interior",
}

export const CAR_IMAGE_FALLBACK =
  "https://parkplus-bkt-img.parkplus.io/production/fuel-bill/public/Banner013_20230727191745795308.png";

export enum ScoreKeys {
  Image = "image",
  Colors = "colors",
  View = "view",
  EMI = "emi",
  Specifications = "specifications",
  Variants = "variants",
  Compare = "compare",
  SimilarCarCompare = "similar_car_compare",
  Review = "review",
  ThreeSixty = "360",
  Price = "price",
  ViewAllFeatures = "view_all_features",
  ContactStrip = "contact_strip",
  City  = "city",
}
